// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1h5fw","header":"PatientBlock_header__3vRGa","label":"PatientBlock_label__SLT2U","option":"PatientBlock_option__1z9T7"};